<div class="coworker-home-container">
  <div *ngIf="showFilters" class="filters">
    <div class="header">
      <span (click)="cleanFilters()">{{
        "coworker.home.filters.delete" | translate
      }}</span>
      <h3>{{ "coworker.home.filters.filters" | translate }}</h3>
      <img [src]="getCloseIcon" (click)="toggleFilters()" />
    </div>
    <div class="container">
      <div class="wrapper">
        <span class="title">{{ "coworker.home.filters.day" | translate }}</span>
        <div class="datepicker-wrapper">
          <cowing-datepicker
            (click)="setNewDay($event)"
            [value]="filterDay"
          ></cowing-datepicker>
        </div>
      </div>
      <div class="wrapper">
        <span class="title">{{
          "coworker.home.filters.duration" | translate
        }}</span>
        <div class="horizontal-list">
          <cowing-element
            *ngFor="let duration of durations"
            [label]="duration.title"
            (event)="setNewDuration($event)"
            [selected]="selectedDuration === duration"
          >
          </cowing-element>
        </div>
      </div>
      <div class="wrapper">
        <div class="inline">
          <span class="title">{{
            "coworker.home.filters.distance" | translate
          }}</span>
          <span class="tag">{{ currentDistance }}Km</span>
        </div>

        <cowing-slider
          (valueChanged)="newDistance($event)"
          [value]="currentDistance"
        ></cowing-slider>
      </div>
      <div class="wrapper">
        <span class="title">{{
          "coworker.home.filters.type" | translate
        }}</span>
        <div class="horizontal-list">
          <cowing-element
            *ngFor="let type of spaceTypes"
            [label]="type.title"
            (event)="setNewType($event)"
            [selected]="selectedSpaceType === type"
          >
          </cowing-element>
        </div>
      </div>

      <div class="wrapper">
        <div class="inline">
          <span class="title">{{
            "coworker.home.filters.price" | translate
          }}</span>
          <span class="tag">{{ currentPrice }}C</span>
        </div>
        <cowing-slider
          (valueChanged)="newPrice($event)"
          [value]="currentPrice"
        ></cowing-slider>
      </div>
    </div>
    <div class="footer">
      <cowing-button
        (event)="search()"
        [label]="'coworker.home.filters.search' | translate"
      >
      </cowing-button>
    </div>
  </div>
  <div class="header">
    <img
      *ngIf="viewMode === ECoworkerView.List"
      [src]="getMapIcon"
      (click)="setView(ECoworkerView.Map)"
    />
    <img
      *ngIf="viewMode === ECoworkerView.Map"
      [src]="getListIcon"
      (click)="setView(ECoworkerView.List)"
    />
    <div class="filter-cities">
      <cowing-input-dropdown
              [iconShow]="true"
              [inputStyle]="EInputStyleType.Secondary"
              [isForm]="false"
              [options]="citiesOptions"
              (selectedValue)="newCity($event)"
      >
      </cowing-input-dropdown>
    </div>
    <img [src]="getFilterIcon" (click)="toggleFilters()" />
  </div>
  <div *ngIf="viewMode === ECoworkerView.Map" class="content map">
    <div #map style="width: 100%; height: 100%"></div>
    <div *ngIf="showSelected" class="selected-map-coworking">
      <cowing-coworker-card
        [isMobile]="isMobile"
        (close)="resetSelected()"
        [showClose]="showSelected"
        [coworking]="selectedMarker.coworking"
        [previous]="'home'"
      >
      </cowing-coworker-card>
    </div>
  </div>
  <div
    *ngIf="viewMode === ECoworkerView.List && coworkingsList.length"
    class="content list"
  >
    <div class="card-wrapper" *ngFor="let coworking of coworkingsList">
      <cowing-coworker-card [coworking]="coworking" [isMobile]="isMobile" [previous]="'home'"></cowing-coworker-card>
    </div>
  </div>
  <div class="tabs">
    <cowing-tabs [active]="EActiveTab.Explore"></cowing-tabs>
  </div>
  <cowing-core-cowing-dialog [isOpen]="modalMobile" (toggle)="toggleModal($event)" [url]="storeUrl"></cowing-core-cowing-dialog>
</div>
